import { Alert, Chip, Stack, Typography } from "@mui/material";
import PowerTable from "../components/PowerTable";
import { usePowerData } from "../hooks/usePowerData";

const LogsPage = () => {
  const { rows, isLoading, error, source } = usePowerData();

  return (
    <Stack spacing={3}>
      <Stack spacing={1.5}>
        <Typography variant="h3">System Logs</Typography>
        <Typography color="text.secondary" maxWidth={620}>
          Detailed readings captured from each connected room device. Sort,
          filter, and export as needed.
        </Typography>
        <Chip
          label={source === "api" ? "Live data" : "Cached data"}
          color={source === "api" ? "primary" : "default"}
          sx={{ alignSelf: "flex-start" }}
        />
      </Stack>

      {error ? <Alert severity="info">{error}</Alert> : null}

      <PowerTable rows={rows} loading={isLoading} />
    </Stack>
  );
};

export default LogsPage;
